import Vue from 'vue'
import Mint from 'mint-ui'
import './style/style.css'
import router from './router/index'
import store from './store/'
import {envId, npm_env, pro_name} from './config/env'
import { init } from '@youshu/mono-sdk'
import { isEmpty } from '@youshu/mono-tools'
import AppE from './App'
import sensors from 'sa-sdk-javascript';
import { version } from '../package.json'
import FastClick from 'fastclick'
import * as filters from './config/filters'
Vue.use(Mint);
// 需要改成按需加载------------------
import vueEventCalendar from '../public/static/eventCalendar.js'
Vue.use(vueEventCalendar)
// 需要改成按需加载------------------

// 微信标签
// Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.ignoredElements = ['root', 'block', /^taro-/, 'wx-open-launch-weapp']

// 神策初始化
import sensorsInit from './config/sensors'
sensorsInit()

// npm组件库
import ys from 'youshuSubscription'
Vue.use(ys, {
    env: npm_env,
    admin: '',
    proname: pro_name
})

// npm方法库
import youshu ,{ Tools } from 'youshumethod'
Vue.use(youshu, {
    env: npm_env,
    admin: '',
    proname: pro_name
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 初始化sentry
// import sentryInit from "./config/errorLog";
// sentryInit(router);

// 初始化card 组件
import yscard from '@youshu/card'
import '@youshu/card/dist/css/ys-card40.css'
import '@youshu/card/dist/css/weui.css'
import './style/ys-card.font.css'
import { applyPolyfills, defineCustomElements } from '@tarojs/components/loader'
applyPolyfills().then(() => {
    defineCustomElements();
});

// FastClick 初始化
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function() {
    FastClick.attach(document.body);
  }, false);
}
try {
  FastClick.prototype.focus = function(targetElement) {
    let length;
    if (
      targetElement.setSelectionRange &&
      targetElement.type.indexOf("date") !== 0 &&
      targetElement.type !== "time" &&
      targetElement.type !== "month"
    ) {
      length = targetElement.value.length;
      targetElement.focus();
      targetElement.setSelectionRange(length, length);
    } else {
      targetElement.focus();
    }
  };
}catch (e) {

}

try{
    // 开发环境添加 移动端 Web 调试工具
    if (process.env.NODE_ENV === "development" || process.env.VUE_APP_WEB_ENV == 'zaia' || process.env.VUE_APP_WEB_ENV == 'qa' || process.env.VUE_APP_WEB_ENV == 'pre' || Tools.cookie.get("HTTP_X_YS_UID") == '32160507' || Tools.cookie.get("HTTP_X_YS_UID") == '17591053' || Tools.cookie.get("HTTP_X_YS_UID") == '4123117' || Tools.cookie.get("HTTP_X_YS_UID") == '30589707' || Tools.cookie.get("HTTP_X_YS_UID") == '24987956') {
        window.vConsole = new VConsole();
    }
}
catch(err){

}

window.Vue = Vue


async function render() {
    import('@tarojs/components/dist/taro-components/taro-components.css')
    await import('@tarojs/components/dist-h5/vue')

    const [initErr, initRes] = await init({
        environment: npm_env,
        proName: pro_name,
        versions: version,
        sentryDSN: 'https://8adbaf84980641c6946120ff64206352@sentry2.youshu.cc/22',
        excludeCode: [
            1, 1010, 1604, 100300000, 2001003, 2002003, 300, 3001, 3002, 3003, 4001, 4002, 10005, 9999, 7510005
        ],
        sentryAdditionalConfig: {
          ignoreErrors: [
            "Cannot read property 'code' of undefined",
            "CustomEvent: Non-Error exception captured with keys",
            "callbackshareapp",
            "WeixinOpenTags"
          ],
          denyUrls: []
        }
    })
    if (!isEmpty(initErr)) {
        console.log('initErr', initErr) // undefined
        return
    }
    console.log(initRes)

    Vue.use(yscard, {
        env: npm_env,
        platform: 'h5',
        sensors: sensors,
        proname: pro_name
    })

    var app = new Vue({
        router,
        store,
        render: h => h(AppE)
    }).$mount('#app')
    window.app = app
}

render();

